import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCanvasActiveDraftWorkflowIdCacheKeys: AllRouteEndpoints[] = [];
